import React, { useEffect, useRef, useState } from "react";
import { message, Popconfirm, Switch, Table, Image, Modal } from "antd";
import { useWaitCollectModel } from "./waitPayModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useCashPayModel } from "../../cashPayModel";
import { EditableCell, EditableRow } from "@/components/YHTable/editTable";
import { billService } from "../../../../bill/BillService";
import { IBillCancel, IBillCashDetail } from "../../../../bill/BillTypes";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { tradeTypeDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { ICashBatchCollect } from "../../../CashTypes";
import { cashService } from "../../../CashService";
import { ColumnsType, ColumnType } from "antd/lib/table";
import { OptionDsType } from "@/types/FmsTypes";
import { forFind } from "@/utils/utils";
import { useLockFn } from "ahooks";
import { getBaseImgLookUrl } from "@/utils/constants";
import FontIcon from "@/components/YhIcon";
import { fileDownload } from "@/utils/exportFile";
import { UploadFile } from "antd/lib/upload/interface";


interface PostDataList {
    id: string;
    [key: string]: string | null | number | boolean;
}

type dataSourceType = IBillCashDetail & {
    id: string,
    partnerCode: string;
    beCode: string;
}
type AccountDsType = {
    label: string,
    value: string,
    codes: string
}

export const CollectBatchDrawer = () => {
    const {
        onReset,
        selectedData,
        collectBatchDrawerVisible,
        loadData,
        setCollectBatchDrawerVisible,
    } = useWaitCollectModel(model => [model.collectBatchDrawerVisible]);
    const { user } = useGlobalModel(model => [model.user])
    const [dataSource, setDataSource] = useState<dataSourceType[]>([])
    const [accountTypeDs, setAccountTypeDs] = useState<OptionDsType[]>([]) //实时存取收款账户类型值
    const [timer, setTimer] = useState<NodeJS.Timeout>()

    useEffect(() => {
        collectBatchDrawerVisible && initData()
    }, [collectBatchDrawerVisible])


    const initData = () => {
        const arr: dataSourceType[] = []
        selectedData.forEach(item => {
            item?.billCashDetailList?.forEach((catchItem, index) => {
                arr.push({
                    ...catchItem,
                    id: catchItem?.key as string ?? index,
                    code: item.tradeCode,
                    partnerCode: item.partnerCode as string,
                    beCode: item?.beCode as string,
                })
            })
        })
        setDataSource(arr);
    }

    const {
        orgDs,
        beDs,
        payMethodDs,
    } = useCashPayModel(model => [
        model.orgDs,
        model.beDs,
        model.payMethodDs,
    ])
    // const formRef = useRef<IYhFormRef>();
    interface IColumnType<RecordType> extends ColumnType<RecordType> {
        editInd: number;
        editable?: boolean;
        editType?: string;
        selectList?: OptionDsType[];
        prefix?: string;
        suffix?: string;
    }
    type IColumnsType<RecordType> = IColumnType<RecordType>[]
    // 根据收款方式查询账户类型
    const queryAccount = async (partnerCode: string, accountTypeCode: string, beCode: string) => {
        debugger;
        let params = {
            partnerCode,
            accountTypeCode,
            sourceApp: "",
            beCode
        }
        let { retData } = await cashService.accountFind(params)
        setAccountTypeDs(retData.map(item => ({ label: item.name, value: item.code })))
    }
    const MethodChange = (value: string, options: any) => { //ITreeData<IMdDictFields>
        debugger
        // const partnerCode = selectedData?.partnerCode as string
        // if (options && options.el.value) {
        //     queryAccount(partnerCode, options.el.value as string)
        // }
    }
    const shelfFocus = (record: PostDataList) => {
        debugger
        const partnerCode = record?.partnerCode as string
        let payMethodCodes = forFind(payMethodDs as any[], record["payMethodCode"] as string, "value")?.el?.value
        // console.log(payMethodCodes)
        // let payMethodCodes = payMethodDs?.find(index => index.value === record["payMethodCode"])?.codes

        if (record["payMethodCode"] && payMethodCodes) {
            queryAccount(partnerCode, payMethodCodes as string, record?.beCode as string)
        } else {
            // setAccountTypeDs([]);
        }
    }
    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const columns = [{
        align: "center",
        title: "业务编号",
        dataIndex: "code",
        editable: false,
        width: 220,
    }, {
        //     align: "center",
        //     title: "单位编码",
        //     hiddle: true,
        //     dataIndex: "partnerCode",
        //     editable: false,
        // }, {
        //     align: "center",
        //     title: "实体",
        //     hiddle: true,
        //     dataIndex: "beCode",
        //     editable: false,
        // }, {
        align: "center",
        title: '付款方式',
        dataIndex: 'payMethodCode',
        editInd: 2,
        editable: false,
        editType: "treeSelect",
        treeList: payMethodDs,
        selectList: payMethodDs,
        onTreeSelect: MethodChange,
        width: 220,
        render: (v: string) => forFind(payMethodDs as any[], v, "value")?.title || '请选择支付方式'
        // render: (v: string) => '请选择支付方式'
    },
    {
        align: "center",
        title: '付款账户',
        dataIndex: 'accountCode',
        editInd: 2,
        editable: false,
        editType: "select",
        selectList: accountTypeDs,
        onSelectFocus: shelfFocus,
        width: 220,
        render: (v: string, record: any) => record.accountName || '请选择付款账户'
    },
    {
        align: "center",
        title: '付款金额',
        dataIndex: 'payAmount',
        editable: false,
        editType: "input",
        editInd: 2,
        prefix: "￥",
        suffix: "元",
        width: 100
    },
    {
        align: "center",
        title: '付款人',
        dataIndex: 'operator',
        editable: false,
        editType: "input",
        editInd: 3,
        width: 120,
        render: (v: string) => v ?? '请输入付款人'
    },
    {
        align: 'center',
        title: '凭证',
        dataIndex: 'cashAttach',
        width: 220,
        render: (v: string | '', record: any) =>
            v && (
                <FontIcon
                    onClick={() => {
                        onPreview({ uid: v, name: record.cashAttachFileName })
                    }}
                    style={{ fontSize: '48px' }}
                    type="icon-tupian"
                />
            ),
    },
        // {
        //     align: "center",
        //     title: '操作',
        //     dataIndex: 'customerStatus',
        //     render: (text: number, record: any) => <div className="flex justify-around">
        //         <PlusOutlined
        //             style={{ fontSize: '18px', cursor: 'pointer' }}
        //             onClick={() => handleAdd(record)}
        //         />
        //         <DeleteOutlined
        //             style={{ fontSize: '18px', cursor: 'pointer' }}
        //             onClick={() => handleRemove(record)}
        //         />
        //     </div>,
        //     editInd: 8,
        // },
    ];
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const newItemColumns = columns.map(col => {
        return {
            ...col,
            onCell: (record: PostDataList) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title as string,
                editType: col.editType,
                prefix: col.prefix,
                suffix: col.suffix,
                selectList: col.selectList,
                treeList: col.treeList,
                checkAll: false,
                handleSave: handleSave,
                enterRow: enterRow,
                // onSelectChange: col?.onSelectChange,
                // onTreeSelect: col?.onTreeSelect,
                // onSelectFocus: col?.onSelectFocus,
                column: columns,
                editList: dataSource,
            }),
        }
    })

    // 加载收付款明细
    // const loadCashList = async () => {
    //     const code = selectedData?.code as string
    // let { retData } = await billService.one(code);
    //     let data = retData.billCashDetailList?.map((item, index) => {
    //         return {
    //             ...item,
    //             id: item?.key ?? index,
    //         }
    //     })
    //     setDataSource(data as dataSourceType[]);
    //     if (data?.length === 0) {
    //         handleAdd({})
    //     }
    // }

    // 新增明细
    // const handleAdd = (row: any) => {
    //     let timer = new Date().getTime().toString()
    //     const initDataSourceOne: dataSourceType = {
    //         key: timer,
    //         id: timer,
    //         payMethodCode: payMethodDs === undefined ? '' : '',//payMethodDs[0].value,
    //         accountCode: null,
    //         accountName: null,
    //         payAmount: 0,
    //         operator: user.userName,
    //     }
    //     setDataSource([
    //         ...dataSource,
    //         initDataSourceOne
    //     ])
    // }
    // 删除明细
    // const handleRemove = (row: any) => {
    //     let filter = dataSource.filter(item => item.id !== row.id)
    //     setDataSource(filter)
    // }

    const handleSave = (row: PostDataList) => {
        row.accountName = accountTypeDs?.find(index => index.value === row.accountCode)?.label ?? null
        const index = dataSource.findIndex((item) => {
            return row.id === item.id
        });
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setDataSource([...dataSource]);
    }
    //回车行选事件
    const enterRow = (row: PostDataList) => {

    }



    // 确认付款
    const onOk = useLockFn(async () => {
        try {
            if(dataSource.length === 0){
                return
            }
            if (timer) {
                clearTimeout(timer)
                setTimer(undefined)
              }
            const reqData: ICashBatchCollect = selectedData.map(item => ({ code: item.code as string, billCashDetailList: item?.billCashDetailList as IBillCashDetail[] }))
            let { retData, retMsg } = await cashService.batchCollect(reqData);
            if (retData) {
                message.success("付款成功!");
                const time = setTimeout(() => {
                    onReset()
                }, 1000)
                setTimer(time)
                onCancel()
            } else {
                message.error("调额失败!" + retMsg);
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    });

    const onCancel = () => {
        setCollectBatchDrawerVisible(false);
        setDataSource([])
    };

    // 驳回
    const onReject = async () => {
        try {
            const reqData: IBillCancel = {
                // code: selectedData?.code as string,
                // branch: selectedData?.branch,
                // partnerTypeCode: selectedData?.partnerTypeCode,
                canceller: user.userName,
            };
            let insertRet = await billService.cancel(reqData);
            if (insertRet.success) {
                message.success("驳回成功!");
                onReset();
                onCancel()
            } else {
                message.error("驳回失败!" + insertRet.retMsg);
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    }

    return (
        <AppDrawer
            {...{
                title: "现金批量付款",
                visible: collectBatchDrawerVisible,
                okText: '确认付款',
                onOk,
                cancelText: '关闭',
                onCancel,
                showFooter: true,
                width: 1000,
                // footerButs: [{
                //     text: '驳回账单',
                //     onClick: onReject
                // }]
            }}
        >
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSource as unknown as PostDataList[]}
                columns={newItemColumns as IColumnsType<PostDataList>}
                pagination={false}
            />
        </AppDrawer>
    )
}
